import { FC } from 'react'
import { Row, Divider } from 'antd'
import { content } from '../components'
import { useAppSelector } from 'src/app/hooks'
import { saleDetailsSelector } from 'src/features'
import { getBigSaleProjectImage } from 'src/core/helpers'
import styles from './MySaleDetailsPageContent.module.scss'
import { CustomCard, OrderItemImage, CustomCol } from 'src/components'

const MySaleDetailsPageContent: FC = () => {
  const { loading, sale } = useAppSelector(saleDetailsSelector)
  const isLoading = loading || !sale

  return <CustomCard loading={isLoading}>
    {!isLoading && <>
      <Row>
        <CustomCol className={styles.boxDetails}>
          <content.SaleSmallDetails sale={sale} />
        </CustomCol>
        <CustomCol>
          <OrderItemImage image={getBigSaleProjectImage(sale)} />
        </CustomCol>
      </Row>
      
      {!sale.supplierInvoice && (<>
        <Divider />
        <Row>
          <CustomCol className={styles.left}>
            <content.SaleProjectDetails sale={sale} />
          </CustomCol>
          <CustomCol className={styles.right}>
            <content.SaleInvoicesDetails sale={sale} />
          </CustomCol>
        </Row>
      </>
      )}
      {sale.supplierInvoice && (
        <>
          <Divider />
          <content.SaleSupplierInvoiceDetails sale={sale} />
        </>
      )}
      <Divider />
      <content.SaleClientDetails sale={sale} />
      <Divider />
      <content.SaleSupplierInvoiceDocument sale={sale} />
      <Divider />
      <content.SaleDocuments sale={sale} />
    </>}
  </CustomCard>
}

export default MySaleDetailsPageContent
